/* unplugin-vue-components disabled */import script from "./MainLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainLayout.vue?vue&type=script&lang=ts&setup=true"

import "./MainLayout.vue?vue&type=style&index=0&id=7e662a85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e662a85"]])

export default __exports__